export default __webpack_public_path__ + "static/media/manzil_case_study_hero.png.webp";